import { Type } from "@angular/core";
import { OpenPurchaseOrdersByDepartmentChartComponent, PoStatusChartComponent, RequisitionApprovalChartComponent, RequisitionStatusChartComponent } from "./components";

export * from "./provider";
export * from "./aggregateActionHandlers";
export * from "./components";
export
{
    PurchasingModuleControl,
    RequisitionModel,
    RequisitionItemModel,
    BidQuoteModel,
    ItemDistributionModel
} from "./interfaces";

export
{
    DepartmentLookupService,
    EPurchasingService,
    LegacyRequisitionService,
    ModuleControlService,
    PurchaseOrderLookupService,
    PurchaseOrderService,
    PurchasingChartService,
    PurchasingDialogsService,
    ReceiveGoodsService,
    ReqAndPoLookupService,
    RequestedByLookupService,
    RequisitionApprovalService,
    RequisitionLookupService,
    RequisitionSearchService,
    RequisitionService,
    ModuleControlService as PurchasingModuleControlService
} from "./services";

export const PO_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "Purchasing.OpenPurchaseOrdersByDepartmentChart": OpenPurchaseOrdersByDepartmentChartComponent,
    "Purchasing.PoStatusChart": PoStatusChartComponent,
    "Purchasing.RequisitionApprovalChart": RequisitionApprovalChartComponent,
    "Purchasing.RequisitionStatusChart": RequisitionStatusChartComponent
};
